module.exports = __webpack_public_path__ + "img/3.2e64034e.png";